import {
  StyledItem,
  Info,
  ColorCircle,
  SquareButton,
  ButtonsWrapper,
  SettingItemIcon,
} from './StyledComponents';

const SettingItem = ({ item, editItem, deleteItem }) => {
  return (
    <StyledItem>
      <Info>
        <ColorCircle color={item.color} />
        {item.label || item.name}
      </Info>
      <ButtonsWrapper>
        <SquareButton onClick={() => editItem()}>
          <SettingItemIcon className="fa-light fa-pencil" />
        </SquareButton>
        <SquareButton
          onClick={() => {
            deleteItem(item);
          }}
        >
          <SettingItemIcon className="fa-light fa-trash-can" />
        </SquareButton>
      </ButtonsWrapper>
    </StyledItem>
  );
};

export default SettingItem;
